export default {
  handler: 'relativeUrl',
  data: () => '/live/streamable',
};
